import { Reveal, Overline } from "./Reveal";
import { WHY, IMAGES } from "../../lib/site";

export default function Why() {
  return (
    <section className="relative bg-travertine pt-10 pb-24 md:pt-16 md:pb-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid lg:grid-cols-3 gap-14">
        <div className="lg:col-span-1">
          <Reveal><Overline>Why Casa Galênê</Overline></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-serif font-light text-4xl sm:text-5xl text-ocean-teal leading-tight">
              A meticulous standard of care, upheld on every visit.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-10 h-64 overflow-hidden rounded-sm shadow-[0_30px_60px_-25px_rgba(10,75,84,0.2)]">
              <img src="/clean-products-teal.png" alt="Teal cleaning gloves and premium eco-friendly cleaning products on a travertine bench" className="h-full w-full object-cover" />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-2 grid sm:grid-cols-2 gap-x-10 gap-y-10">
          {WHY.map((w, i) => (
            <Reveal key={w.title} delay={i * 0.08}>
              <div className="h-full rounded-xl border border-white/40 bg-white/15 backdrop-blur-sm p-6 shadow-[0_12px_40px_-20px_rgba(10,75,84,0.3)] transition-all duration-500 hover:bg-white/30 hover:-translate-y-1">
                <div className="flex items-baseline gap-3">
                  <span className="font-serif text-antique-gold text-lg">0{i + 1}</span>
                  <h3 className="font-serif text-2xl text-ocean-teal">{w.title}</h3>
                </div>
                <p className="mt-3 font-sans font-light text-sm leading-relaxed text-ocean-teal/80">{w.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
